import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Table, Popconfirm, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Icon, Widget } from 'dlweb-components';
import styled from 'styled-components';

const FileTable = ({files, selectedFile, setSelectedFile, sourceFiles, fileProgress, removeFile, isUploading, processing, showLocalFilePicker, onSourceSelect}) => {

  const onRemoveFile = (e, file) => {
    e.stopPropagation();
    removeFile(file);
  }

  const rowSelection = {
    selectedRowKeys: [selectedFile?.ID],
    onSelect: (selectedKey, selected) => {
      setSelectedFile([selectedKey]);
    }
  };

  const onRowClick = (event, record) => {
    if (event.target.className.indexOf('ant-checkbox') > -1) return;
    setSelectedFile(record);
  }

  const FileColumn = ({record}) => (
    <div style={{ display: 'flex', alignItems: 'center', height: '25px' }}>
      <div style={{overflow: 'hidden', width: '100%', display: 'flex', alignItems: 'center'}}>
        <div className={`file-icon-small files-small-${record.ObjectType}`} style={{marginRight: '10px'}}></div>
        <div style={{whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', paddingRight: '10px'}}>
          {`${record.FileName}${record.ObjectType ? '.' + record.ObjectType : ''}`}
        </div>
      </div>
      {!window.chrome?.webview &&
      <>
        {!sourceFiles[record.ID] &&
          <div>
            <Button size='small' type="primary" onClick={() => showLocalFilePicker(record)}>
              Choose File
            </Button>
          </div>
        }
        {sourceFiles[record.ID] &&
          <Tooltip title={sourceFiles[record.ID].name}>
            <div style={{cursor: 'pointer'}} onClick={(e) => { e.stopPropagation(); showLocalFilePicker(record)}}>
                <Icon type="file-check" style={{color: '#94b7d3'}} faStyle="fas" />
            </div>
          </Tooltip>
        }
      </>
      }
      {files.length > 1 &&
        <RemoveButton onClick={(e) => onRemoveFile(e, record)}>
          <Icon type='times'/>
        </RemoveButton>
      }
    </div>
  )

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      ellipsis: true,
      width: '70%',
      render: (text, record) => <FileColumn record={record} />,
    }
  ];
 
  return (
    <Table
      rowKey="ID"
      size="small"
      tableLayout="fixed"
      showHeader={false}
      dataSource={files}
      columns={columns}
      rowClassName="editable-row"
      pagination={false}
      className="hide-selection-column"
      // scroll={{ y: 'calc(100% - 400px)' }}
      rowSelection={{
        type: 'radio',
        ...rowSelection,
      }}
      onRow={(record, rowIndex) => {
        return {
          onClick: event => onRowClick(event, record),
          onContextMenu: event => event.preventDefault() //openContextMenu(event, record)
        };
      }}
    />
  );

}

const RemoveButton = styled.div`
  color: #888;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  cursor: pointer;
  :hover {
    color: #000;
  }
`

const mapStateToProps = state => {
  const { upload } = state;
  return { upload };
};

export default connect(mapStateToProps)(FileTable);